import React from "react";
import { ManageFundingDetailsContainer } from "../../../containers";

const ManageFundingDetails = (props) => {
  return <ManageFundingDetailsContainer {...props} />;
};

export default ManageFundingDetails;
